import { render, staticRenderFns } from "./FormLayoutComponents.vue?vue&type=template&id=222f02a8&"
import script from "./FormLayoutComponents.vue?vue&type=script&lang=js&"
export * from "./FormLayoutComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports